// src/components/Navbar.js
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./navbar.css";

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-inner">

        {/* LEFT : LOGO */}
        <div className="navbar-left">
          <img
            src="/shamshine_nobg.png"
            alt="Shamshine Logo"
            className="logo-img"
          />
          <span className="logo-text">Shamshine Pte Ltd</span>
        </div>

        {/* DESKTOP LINKS */}
        <div className="navbar-center desktop-only">
          <NavLink to="/" end>Why Shamshine?</NavLink>
          <NavLink to="/references">Project References</NavLink>
          <NavLink to="/services">Services</NavLink>
          <NavLink to="/contact">Contact Us</NavLink>
        </div>

        {/* HAMBURGER (MOBILE) */}
        <div
          className={`hamburger ${menuOpen ? "active" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span />
          <span />
          <span />
        </div>
      </div>

      {/* MOBILE MENU */}
      <div className={`mobile-menu ${menuOpen ? "open" : ""}`}>
        <NavLink to="/" end onClick={closeMenu}>
          Why Shamshine?
        </NavLink>
        <NavLink to="/references" onClick={closeMenu}>
          Project References
        </NavLink>
        <NavLink to="/services" onClick={closeMenu}>
          Services
        </NavLink>
        <NavLink to="/contact" onClick={closeMenu}>
          Contact Us
        </NavLink>
      </div>
    </nav>
  );
}
